import Enum from './core/enum'

// 插件-枚举管理
const install = function(Vue, options = {}) {
	// config
	Object.keys(Enum.options).forEach(k => {
		if (options[k]) {
			Enum.options[k] = options[k]
		}
	})

	// Vue
	Vue.mixin({
		beforeCreate() {
			this.$enum = Enum
		}
	})

	Vue.$enum = Enum
}

export default install
export { Enum }